import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import server, { TaskWebSocketServer, commandSocketServer } from '@/config';
import readCookie from './functions/readCookie';

import router from '../router';
import * as Mutations from './mutation-types';

import userModule from './module/user';
import drugModule from './module/drug';
import deviceModule from './module/devices';
import drugInDeviceModule from './module/drugInDevice';
import eventModule from './module/event';
import scheduleModel from './module/schedule';


Vue.use(Vuex);


// detecte drawer in errorDevices.
function hasOnlyDrawer(errorDevices) {
  if (errorDevices.length === 1 && errorDevices[0].type === 'drawer') return true;
  return false;
}

// detect box in errorDevices.
function hasBox(errorDevices) {
  for (let i = 0; i < errorDevices.length; i += 1) {
    if (errorDevices[i].type === 'box') return true;
  }
  return false;
}

// filter out force_shutdown system and disabled devices from errorDevices.
function filterErrorDevices(systems, disableDevices, errorDevices) {
  const systemStatus = [];
  let filterDevices = errorDevices;

  // filter out force shutdown system
  if (systems.length > 0) {
    Object.values(systems).forEach((sys) => {
      systemStatus.push(!sys.force_shutdown);
    });
    filterDevices = _.filter(filterDevices, (dev) => { return systemStatus[dev.system]; });
  }

  // filter out disabled devices.
  if (disableDevices.length > 0) {
    disableDevices.forEach((disDev) => {
      if (disDev.pos_row === 0) { // filter out drawer
        filterDevices = _.reject(filterDevices, { system: disDev.net.system.relative_index - 1, drawerId: disDev.net.row_id });
      }
      filterDevices = _.reject(filterDevices, { system: disDev.net.system.relative_index - 1, drawerId: disDev.net.row_id, col: disDev.relative_col, row: disDev.pos_row });
    });
  }
  return filterDevices;
}


// NOTICE: object would not be detected instaly in vue instace.
const state = {
  progress: [],                             // progress steps shows on progressbar.vue
  showLogout: false,                        // show logout button
  showLoader: false,                        // show global loader
  currentStep: '',                          // current step in progress
  generalSetting: null,                     // the settings of this system fetched from backend
  instance: undefined,                      // axios instance
  expiredDrugCount: 0,                      //
  modalStatus: {                            // modalStatus: use for specific modal.
    lowAmount: false,
    lockDevice: false,
    lockDrawer: false,
    medGroupSelect: false,
  },
  message: {
    type: '',
    status: false,
    context: '',
    keepOnTop: false,
    showLockDevice: false,
  },
  messagePop: false,
  currentApp: {
    name: '',
    cancel: true,
  },
  timeoutId: null,
  logoutAccuTime: 0,
  humidity: 0,
  temperature: 0,
  frontendLogined: false,
  loginedUsers: [],
  connectionStatus: null,
  systemLayoutChecked: false,
  disableDevices: [],
  webSocket: null,
  webSocketReady: false,
  cabinetSerials: [],
  fingerprinterStatus: undefined,
  fingerprinterConnected: false,
  checkFingerprinterStatusFn: undefined,
  apps: {
    management: {
      title: '藥物管理',
      functions: {
        schedule: {
          name: '醫囑取藥',
          icon_name: 'calendar-drug.svg',
          url_name: 'schedule',
          privilege: false,
          ready: true,
        },
        scheduleReturn: {
          name: '醫囑退藥',
          icon_name: 'calendar-arrow.svg',
          url_name: 'scheduleReturn',
          privilege: true,
          ready: true,
        },
        fetchDrug: {
          name: '一般取藥',
          icon_name: 'medical-drug-pill.svg',
          url_name: 'fetchDrug',
          privilege: false,
          ready: true,
        },
        returnDrug: {
          name: '一般退藥',
          icon_name: 'back-arrow.svg',
          url_name: 'returnDrug',
          privilege: false,
          ready: true,
        },
        refillDrug: {
          name: '補充藥物',
          icon_name: 'medicine-bottle.svg',
          url_name: 'refillDrug',
          privilege: false,
          ready: false,
        },
        inventory: {
          name: '盤點藥物',
          icon_name: 'cabinet.svg',
          url_name: 'inventory',
          privilege: false,
          ready: true,
        },
        createDrug: {
          name: '新增藥物',
          icon_name: 'add-tool.svg',
          url_name: 'createDrug',
          privilege: false,
          ready: true,
        },
        removeDrug: {
          name: '移除藥物',
          icon_name: 'round-delete-button.svg',
          url_name: 'removeDrug',
          privilege: false,
        },
        removeOutdatedDrug: {
          name: '移除過期',
          icon_name: 'time-left.svg',
          url_name: 'removeOutdatedDrug',
          privilege: false,
          ready: false,
        },
        recycleDrug: {
          name: '回收退藥',
          icon_name: 'recycle.svg',
          url_name: 'recycleDrug',
          privilege: true,
        },
        lockBox: {
          name: '藥物保管箱',
          icon_name: 'locked.svg',
          url_name: 'lockBox',
          privilege: false,
          ready: false,
        },
        waste: {
          name: '拋棄藥物',
          icon_name: 'garbage.svg',
          url_name: 'waste',
          privilege: true,
          ready: true,
        },
        fetchDrugSchedule: {
          name: '批次取藥',
          icon_name: 'drug.svg',
          url_name: 'fetchDrugSchedule',
          privilege: false,
          ready: true,
        },
        recycleEmpty: {
          name: '空瓶交換',
          icon_name: 'recycle-vial.svg',
          url_name: 'recycleEmpty',
          privilege: false,
          ready: true,
        },
        returnEmpty: {
          name: '退回空瓶',
          icon_name: 'return-vial.svg',
          url_name: 'returnEmpty',
          privilege: true,
          ready: true,
        },
      },
    },
    setting: {
      title: '藥櫃設定',
      functions: {
        drugInfo: {
          name: '藥物資訊',
          icon_name: 'information-symbol.svg',
          url_name: 'drugInfo',
          privilege: true,
          ready: true,
        },
        userManual: {
          name: '使用者選單',
          icon_name: 'settings-gears.svg',
          url_name: 'userManual',
          privilege: true,
          ready: true,
        },
        setReturnBox: {
          name: '設定退藥盒',
          icon_name: 'export.svg',
          url_name: 'setReturnBox',
          privilege: true,
          ready: true,
        },
        storageError: {
          name: '存量不符',
          icon_name: 'danger.svg',
          url_name: 'storageError',
          privilege: true,
          ready: false,
        },
        drugStorageSummary: {
          name: '藥品統計',
          icon_name: 'result.svg',
          url_name: 'drugStorageSummary',
          privilege: true,
          ready: false,
        },
        disabledDevices: {
          name: '待維修藥盒',
          icon_name: 'wrench.svg',
          url_name: 'disabledDevices',
          privilege: false,
          ready: true,
        },
        // {
        //   name: '藥物複檢',
        //   icon_name: 'correct.svg',
        //   url_name: 'recheckDrug',
        // },
      },
    },
  },
};

const mutations = {
  [Mutations.CREATE_INSTANCE](state) {
    state.instance = axios.create({
      baseURL: server,
      timeout: 600 * 1000, // timeout for 20 secs
      headers: {
        Authorization: `Token ${readCookie('Token')}`,
      },
    });
  },
  // for model message.
  [Mutations.SET_MESSAGE](state, payload) {
    if (state.message.keepOnTop) {
      console.log('previous message is keepOnTop know, close it first to reset.');
    } else {
      state.message.type = payload.type;
      state.message.status = true;
      state.message.context = payload.context;
      state.message.showUnlock = false;
      state.message.confirm = true;
      state.message.keepOnTop = false;
      state.message.showLockDevice = false;

      // set showUnlock attr.
      if (payload.showUnlock !== undefined) {
        state.message.showUnlock = payload.showUnlock;
      }

      // set confirm attr.
      if (payload.confirm !== undefined) {
        state.message.confirm = payload.confirm;
      }

      // keepOnTop: make sure the message would only be closed by confirm button on message comp.
      if (payload.keepOnTop !== undefined) {
        state.message.keepOnTop = payload.keepOnTop;
      }

      if (payload.showLockDevice !== undefined) {
        state.message.showLockDevice = payload.showLockDevice;
      }
    }
  },
  [Mutations.CLOSE_MESSAGE](state, forceClose) {
    if (state.message.keepOnTop && (forceClose === undefined || forceClose === false)) {
      console.log('previous message is keepOnTop know, close it first to reset.');
    } else {
      state.message.status = false;
      state.message.context = '';
      state.message.keepOnTop = false;
    }
  },
  // check message is poped or not
  [Mutations.MESSAGE_POPED](state, status) {
    state.messagePop = status;
  },

  // set app page title.
  [Mutations.SET_APP](state, appName) {
    state.currentApp.name = appName;
  },
  [Mutations.SET_APP_CANCEL_STATUS](state, status) {
    state.currentApp.cancel = status;
  },
  // setup progress bar.
  [Mutations.SET_PROGRESS](state, progress) {
    state.progress = progress;
  },
  // setup which step is now processing.
  [Mutations.SET_CURRENT_STEP](state, step) {
    state.currentStep = step;
  },
  // setup stage in confirm in each app.

  // unify show_modal interface.
  [Mutations.SHOW_MODAL](state, payload) {
    state.modalStatus[payload.modalName] = payload.status;
  },
  [Mutations.FRONETEND_PANEL_USER_LOGINED](state, loginedUsers) {
    state.loginedUsers = loginedUsers;
    if (state.loginedUsers.length === 0) {
      state.frontendLogined = false;
    } else {
      state.frontendLogined = true;
    }
  },
  [Mutations.SHOW_LOGOUT](state, status) {
    state.showLogout = status;
  },
  [Mutations.SHOW_LOADER](state, status) {
    state.showLoader = status;
  },
};

const actions = {
  // flow of init system:
  // send reset command -> get serial -> send checkout layout command -> get layout data -> send layout data -> success
  // -> ask for system id -> get system id -> request system info.
  webSocketConnect({ state, commit, getters, dispatch }) {
    if (state.webSocket === null) {
      state.webSocket = new WebSocket(TaskWebSocketServer);
      // check cabinet series
      state.webSocket.onopen = (e) => {
        console.debug('socket connected.');
        state.webSocketReady = true;
        // dispatch('resetAndGetLocalSerialNumber');
      };

      state.webSocket.onmessage = (e) => {
        // console.debug(e.data);
        try {
          const rawData = JSON.parse(e.data);
          if (rawData.task_status === 'failed') {
            if (rawData.command === 'reset' || rawData.command === 'get_layout' || rawData.command === 'check_status') {
              commit('SET_MESSAGE', { type: 'error', context: '連線有誤，重新嘗試中', confirm: false });
            }
          }
          if (rawData.task_status === 'success') {
            const resultData = rawData.result_data;
            switch (rawData.command) {
              case 'reset': {
                if (state.message.context === '連線有誤，重新嘗試中') commit('CLOSE_MESSAGE');
                // state.connectionStatus = true;
                state.cabinetSerials = resultData.cab_serials;
                dispatch('sendScanLocalLayoutCommand');
                break;
              }
              case 'get_layout': {
                if (state.message.context === '連線有誤，重新嘗試中') commit('CLOSE_MESSAGE');
                axios.post(`${server}/adc-control/consumer_result/`, {
                  command: 'get_layout',
                  data: resultData.layout_data,
                })
                  .then((res) => {
                    if (res.status === 200) {
                      dispatch('initSystem');
                      state.systemLayoutChecked = true;
                    }
                  });
                break;
              }
              case 'check_status': {
                if (state.message.context === '連線有誤，重新嘗試中') commit('CLOSE_MESSAGE');
                state.device.errorDevices = filterErrorDevices(getters.systems, state.disableDevices, resultData.data);
                const env = resultData.env;
                state.humidity = env.humidity;
                state.temperature = env.temperature;
                break;
              }
              case 'capture_finger': {
                if (state.checkFingerprinterStatusFn === undefined) {
                  state.checkFingerprinterStatusFn = setInterval(() => {
                    dispatch('sendCheckFingerPrinterStatusCommand');
                  }, 300);
                }
                break;
              }
              case 'check_fingerprinter_status': {
                const status = resultData.status;
                state.fingerprinterStatus = status;
                if (rawData.task_status === 'failed') {
                  state.fingerprinterConnected = false;
                }

                if (rawData.task_status === 'success') {
                  state.fingerprinterConnected = true;
                }

                if (status === 'finger_captured') {
                  clearInterval(state.checkFingerprinterStatusFn);
                  state.checkFingerprinterStatusFn = undefined;
                  dispatch('sendGetFingerFeatureCommand');
                }
                if (status === 'standby') {
                  clearInterval(state.checkFingerprinterStatusFn);
                  state.checkFingerprinterStatusFn = undefined;
                }
                break;
              }
              case 'get_finger_feature': {
                if (resultData.feature !== '') {
                  state.user.fingerprint = resultData.feature;
                }
                break;
              }
              case 'cancel_capture': {
                clearInterval(state.checkFingerprinterStatusFn);
                state.checkFingerprinterStatusFn = undefined;
                break;
              }
              default: {
                console.warn('command not handled.', rawData);
              }
            }
          }
        } catch (err) {
          console.warn(err);
        }
      };
    }
  },
  submitCommand({ state }, payload) {
    const data = new FormData();
    if (payload.command) data.append('command', payload.command);
    if (payload.appendData) {
      data.append('append_data', payload.appendData);
    } else {
      data.append('append_data', '');
    }
    fetch(commandSocketServer, {
      method: 'POST',
      mode: 'no-cors',
      body: data,
    });
  },
  getStorageError({ state }) {
    state.apps.setting.functions.storageError.ready = false;
    return state.instance.get('/api/event/', {
      params: {
        event: 'STORAGE_ERROR',
        system: state.device.systemId,
        drug_storage__isnull: false,
        checked: 'false',
      },
    })
    .then((res) => {
      res.data.results.forEach((item) => {
        item.selected = false;
        item.device = state.device.allDevices[item.device.id];
      });
      state.drugInDevice.storageError = res.data.results;
      state.drugInDevice.storageErrorCount = res.data.total;
      state.apps.setting.functions.storageError.ready = true;
    });
  },
  // get the content of external device.
  getExternalDevice({ state }) {
    return state.instance.get('/api/external-device/')
    .then((res) => {
      state.externalCmpn = res.data[0];
    });
  },
  getDisabledDevices({ state }) {
    // check whether disabled devices exists.
    state.apps.setting.functions.disabledDevices.privilege = false;
    return state.instance.get('/api/device/', {
      params: {
        net__system__status: 'Ready',
        net__system: state.device.systemId,
        error: true,
      },
    })
      .then((res) => {
        if (res.data.results.length > 0) {
          state.apps.setting.functions.disabledDevices.privilege = true;
        }
        state.disableDevices = res.data.results;
      });
  },
  initSystemInfo({ dispatch, commit, state }) {
    commit('CREATE_INSTANCE');
    const promise = [];
    promise.push(dispatch('getSystemInfo'));
    promise.push(dispatch('getDrugInDevices'));
    promise.push(dispatch('getLowStockDrugInDevice'));
    promise.push(dispatch('getDisabledDevices'));
    promise.push(dispatch('getStorageError'));
    promise.push(dispatch('getExternalDevice'));
    return Promise.all(promise);
  },
  resetAll({ commit }) {
    commit('RESET_DEVICES_MODULE');
    commit('RESET_EVENT_MODULE');
    commit('RESET_DRUG_IN_DEVICE_MODULE');
    commit('RESET_DRUG_MODULE');
    commit('RESET_SCHEDULE');
  },
  resetCabinet() {
    return state.instance.post('/adc-control/reset-cabinet/')
    .then((res) => {
      console.log('reset cabinet');
      // console.log(process);
    });
  },
  setLogoutTimeout({ state, commit }) {
    // console.log('counting up timer for logout');
    state.timeoutId = setInterval(() => {
      state.logoutAccuTime += 1;
    }, 1000);
  },
  removeLogoutTimeout({ state, commit }) {
    // console.log('clear timer for logout');
    clearInterval(state.timeoutId);
    state.logoutAccuTime = 0;
  },
};

// getters should be refracted first
const getters = {
  instance: (state, getters) => {
    return state.instance;
  },
  modalStatus: (state, getters) => {
    return state.modalStatus;
  },
  frontendLogined: (state, getters) => {
    return state.frontendLogined;
  },
  loginedUsers: (state, getters) => {
    return state.loginedUsers;
  },
  connectionStatus: (state) => {
    return state.connectionStatus;
  },
  disableDevices: (state) => {
    return state.disableDevices;
  },
  messageStatus: (state) => {
    return state.message.status;
  },
};


const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [
    // createLogger(),
  ],
  modules: {
    user: userModule,
    drug: drugModule,
    device: deviceModule,
    drugInDevice: drugInDeviceModule,
    event: eventModule,
    schedule: scheduleModel,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js